module.exports = __webpack_public_path__ + "static/assets/b6161b8296af5d040cb270af04f73647.svg";